/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Цикл событий</h2>
    <p className={styles.description}>
      В этой секции вы найдете ссылки на дополнительные материалы о цикле событий в JavaScript - очень важному механизму
      исполнения кода.{' '}
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/8cV4ZvHXQL4" target="_blank" rel="noopener noreferrer">
          Philip Roberts Help I'm stuck in an event loop (видео, перевод)
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/6MXRNXXgP_0" target="_blank" rel="noopener noreferrer">
          Philip Roberts Help I'm stuck in an event loop (видео, оригинал)
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="http://latentflip.com/loupe" target="_blank" rel="noopener noreferrer">
          Playground для разбора цикла событий
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/j4_9BZezSUA" target="_blank" rel="noopener noreferrer">
          Jake Archibald: In The Loop - JSConf.Asia 2018 (видео, перевод)
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/cCOL7MC4Pl0" target="_blank" rel="noopener noreferrer">
          Jake Archibald: In The Loop - JSConf.Asia 2018 (видео, оригинал)
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://youtu.be/bUx8wk4LdoY" target="_blank" rel="noopener noreferrer">
          Асинхронщина в JS под капотом (видео)
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://jakearchibald.com/2015/tasks-microtasks-queues-and-schedules/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Tasks, microtasks, queues and schedules (статья)
        </a>
      </li>
    </ul>
  </section>
))
